module.exports = __webpack_public_path__ + "img/kid_in_stroller.a8d5091b.jpg";